<ng-template #contentTemplate>
    <div fxLayout="row wrap" style="gap: 24px">
        <mat-list fxFlex="1 1 auto" class="mat-elevation-z-1 mat-grey-100 mat-fill app-acrylic" style="border-radius: 16px; padding: 16px 0 0 0">
            <div mat-subheader class="mat-accent-gradient"><mat-icon>mail</mat-icon> Mail</div>
            <mat-list-item style="max-width: 320px;">
                <div matLine>hotline&#64;oxance.fr</div>
                <small matLine class="mat-grey" style="white-space: unset">
                    Afin de vous proposer une meilleure prise en charge et un meilleur suivi de votre demande nous vous conseillons 
                    l'ouverture d'une demande d'intervention.
                </small>
            </mat-list-item>
        </mat-list>
        <mat-list fxFlex="1 1 auto" class="mat-elevation-z-1 mat-grey-100 mat-fill app-acrylic" style="border-radius: 16px; padding: 16px 0 0 0">
            <div mat-subheader class="mat-accent-gradient"><mat-icon>code</mat-icon> Assistance Portail & Intranet (Dev)</div>
            <mat-list-item>
                <div matLine>{{'0476202771' | phoneNumber}}</div>
                <small matLine class="mat-grey">Tapez sur <mat-icon class="mat-primary">looks_one</mat-icon> après le message</small>
            </mat-list-item>
        </mat-list>
        <mat-list fxFlex="1 1 auto" class="mat-elevation-z-1 mat-grey-100 mat-fill app-acrylic" style="border-radius: 16px; padding: 16px 0 0 0">
            <div mat-subheader class="mat-accent-gradient"><mat-icon>support_agent</mat-icon> Assistance Materiels et mails (Infra)</div>
            <mat-list-item>
                <div matLine>{{'0476202771' | phoneNumber}}</div>
                <small matLine class="mat-grey">Tapez sur <mat-icon class="mat-primary">looks_two</mat-icon> après le message</small>
            </mat-list-item>
        </mat-list>
        <mat-list fxFlex="1 1 auto" class="mat-elevation-z-1 mat-grey-100 mat-fill app-acrylic" style="border-radius: 16px; padding: 16px 0 0 0">
            <div mat-subheader class="mat-accent-gradient"><mat-icon>manufacturing</mat-icon> Assistance Logiciels métier</div>
            <mat-list-item>
                <div matLine>{{'0476202771' | phoneNumber}}</div>
                <small matLine class="mat-grey">Tapez sur <mat-icon class="mat-primary">looks_3</mat-icon> après le message</small>
            </mat-list-item>
        </mat-list>
    </div>
    <div fxLayout="row wrap" style="gap: 24px; margin-top: 24px">
        <mat-list *ngIf="me.isAuthenticated" fxFlex="1 0 305px" fxLayout="column" 
            class="mat-elevation-z-1 mat-grey-100 mat-fill app-acrylic" style="border-radius: 16px; padding: 16px 0 0 0">
            <div mat-subheader class="mat-accent-gradient">
                <mat-icon>speaker_notes</mat-icon>
                Demandes d'interventions
            </div>
            <mat-list-item>
                <small matLine class="mat-grey" style="white-space: unset">
                    Pour consulter vos demandes, <a routerLink="/demandes">cliquez ici</a>.
                </small>
            </mat-list-item>
            <mat-list-item style="margin: 0 -8px">
                <button mat-flat-button color="primary" id="demandes-button-new" (click)="openDemande()">
                    <mat-icon>add_comment</mat-icon> Ouvrir une nouvelle demande
                </button>
            </mat-list-item>
        </mat-list>
        <mat-list fxFlex="1 1 auto" class="mat-elevation-z-1 mat-grey-100 mat-fill app-acrylic" style="border-radius: 16px; padding: 16px 0 0 0">
            <div mat-subheader class="mat-accent-gradient">
                <mat-icon>install_desktop</mat-icon>
                Installer le logiciel de télémaintenance
            </div>
            <mat-list-item>
                <small matLine class="mat-grey" style="white-space: unset">
                    Pour des raisons de sécurité, veuillez n'utiliser ces outils qu'a la demande du service informatique.
                </small>
            </mat-list-item>
            <mat-list-item style="margin: 0 -8px">
                <a mat-flat-button color="primary" style="background-color: #4cb7ef" 
                    href="/api/drive/public/01UZ4LSVVFRCZHW77MJ5GJO566GUWXL2NF">
                    <mat-icon svgIcon="logmein"></mat-icon>
                    LogMeIn
                </a>
                <a mat-flat-button color="primary" style="background-color: #004680; margin-left: 8px" 
                    href="/api/drive/public/01UZ4LSVQTPIGH4X5BYREZ5GOGF54CPH2N">
                    <mat-icon svgIcon="teamviewer"></mat-icon>
                    TeamViewer
                </a>
            </mat-list-item>
        </mat-list>
        <mat-list *ngIf="me.isAuthenticated" fxFlex="1 1 auto" class="mat-elevation-z-1 mat-grey-100 mat-fill app-acrylic" style="border-radius: 16px; padding: 16px 0 0 0">
            <div mat-subheader class="mat-accent-gradient">
                <mat-icon>quiz</mat-icon>
                FAQ
            </div>
            <mat-list-item>
                <small matLine class="mat-grey" style="white-space: unset">
                    Pour consulter la FAQ, <a routerLink="/home/faq">cliquez ici</a>, la réponse à votre question s'y trouve peux être.
                </small>
            </mat-list-item>
        </mat-list>
    </div>
</ng-template>

<ng-template #pageTemplate>
    <div style="width: 640px; max-width: calc(100vw - 32px); min-height: 100vh; display: flex !important; flex-direction: column; justify-content: center; 
        align-items: center; margin: 0 auto !important;">
        <div style="position: relative; width: 100%">
            <ng-container>
                <img alt="illustration" src="assets/35.svg" style="position: fixed; width: 675px; transform: translate(-280px, -330px);" loading="lazy"/>
                <img alt="illustration" src="assets/logo-app-details.svg" class="illustration illustration-animated" style="top: -20px; z-index: 1;" loading="lazy" />
            </ng-container>
            <mat-card class="mat-elevation-z4">
                <div *ngTemplateOutlet="contentTemplate"></div>
            </mat-card>
        </div>
    </div>
</ng-template>

<div *ngIf="inline; else pageTemplate">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>